import { render, staticRenderFns } from "./couponList_ks.vue?vue&type=template&id=60385fe5&scoped=true"
import script from "./couponList_ks.vue?vue&type=script&lang=ts"
export * from "./couponList_ks.vue?vue&type=script&lang=ts"
import style0 from "./couponList_ks.vue?vue&type=style&index=0&id=60385fe5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60385fe5",
  null
  
)

export default component.exports